const apiKey = "a6f0fb14228b8c29c088bc76e1efc5";

const query = `
  query {
    navigation {
      navigationElement1
      navigationElement2
      navigationElement3
      navigationElement4
      navigationElement5
      navigationElement6
      navigationElement7
    }
    heroSection {
      heroTitle
      heroText
      heroImage {
        url
      }
    }
    pricing {
      pricingTitle
      seeMoreButton
      seeLessButton
      pricingTextOne
      pricingSubtitleOne
      pricingSubtitleTwo
      pricingTextTwo
      pricingSubtitleThree
      pricingTextThree
      pricingTextFour
      pricingTextFive
      pricingTileOneTitle
      pricingTileOneSubtitle
      pricingTileOnePrice
      pricingTileOneDescription
      pricingTileCallout
      pricingTileTwoTitle
      pricingTileTwoSubtitle
      pricingTileTwoPrice
      pricingTileTwoDescription
      pricingTileThreeTitle
      pricingTileThreeSubtitle
      pricingTileThreePrice
      pricingTileThreeDescription
      pricingTileFourTitle
      pricingTileFourPrice
      pricingTileFiveTitle
      pricingTileFivePrice
      pricingTileSixTitle
      pricingTileSixPrice
      pricingTileSixDescription
      pricingTileSevenTitle
      pricingTileSevenPrice
      pricingTileSevenDescription
      pricingTileNineTitle
      pricingTileNinePrice
      pricingTileTenTitle
      pricingTileTenPrice
      pricingTileElevenTitle
      pricingTileElevenPrice
    }
    foodImage {
      image1 {
        url
      }
      image2 {
        url
      }
    }
    register {
      registerPreText
      registerTitle
      registerPostText
    }
    carousel {
      carouselSlideOneTitle
      carouselSlideOneSubtitle
      carouselSlideTwoTitle
      carouselSlideTwoSubtitle
      carouselSlideThreeTitle
      carouselSlideThreeSubtitle
      image1 {
        url
      }
      image2 {
        url
      }
      image3 {
        url
      }
    }
    benefit {
      benefitTitle
      benefit1
      benefit2
      benefit3
      benefit4
      benefit5
      benefit6
      benefit7
      benefit8
    }
    form {
      formTitle
      formText
      formCallout
      formInfo
      formButton
      formContactInfo1
      formContactInfo2
      formContactInfo3
    }
    about {
      aboutTitle
      aboutSection1Title
      aboutSection1Text
      aboutSection2Title
      aboutSection2Text
      aboutSection3Title
      aboutSection3Text
      aboutSection4Title
      aboutSection4Text
      faqLinkTitle
      faqLinkSubtitle
      faqLinkButton
      image1 {
        url
      }
      image2 {
        url
      }
      image3 {
        url
      }
      image4 {
        url
      }
    }
    footer {
      footerText1
      footerText2
      footerText3
      footerText4
    }
    carousel2 {
      carouselText
      carouselTitle
      categories {
        category
        carouselImages {
          url
          alt
        }
      }
    }
    howItWork {
      title
      titleOne
      textOne
      titleTwo
      textTwo
      titleThree
      textThree
    }
    faqSection {
      title
      subtitle
      faqBlock {
        title
        description
      }
    }
    confirmation {
      title
      subtitle
      button
    }
  }
`;

async function fetchContent() {
  const res = await fetch("https://graphql.datocms.com/", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${apiKey}`,
    },
    body: JSON.stringify({ query }),
  });

  const { data } = await res.json();

  return data;
}

export { apiKey, fetchContent };
